module.exports = __webpack_public_path__ + "media/images/user-e11a6a6cafcab52a878998de5b30551c.svg";